import { createUseStyles } from 'react-jss'
import {
  neonLime,
  black,
  white,
  red,
  neonLimeLight,
  neonLimeDark
} from '../../../styles/colors'
import MediaQueries from '../../../styles/MediaQueries'

const useStyles = createUseStyles({
  emailBoxContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: `radial-gradient(97.73% 49.99% at 58.02% 49.96%, #314505 0%, #000000 100%)`,
    padding: '0 25px'
  },
  title: {
    fontFamily: 'GTWalsheim',
    fontWeight: 400,
    fontSize: '32px',
    lineHeight: '100%',
    textAlign: 'center'
  },
  description: {
    fontFamily: 'GTWalsheim',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '140%',
    textAlign: 'center',
    maxWidth: '850px',

    '@global': {
      a: {
        color: white
      }
    }
  },

  text: {
    fontFamily: 'GTWalsheim',
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '100%',
    textAlign: 'center',
    padding: '16px'
  },

  originalPrice: {
    fontSize: '14px',
    fontFamily: "GothamRounded",
    fontWeight: 500,
    color: neonLime,
    textDecorationLine: 'line-through',
    marginBottom: '10px'
  },

  priceAmount: {
    display: 'flex',
    fontSize: '16px',
    fontFamily: "GothamRounded",
    marginBottom: '4px'
  },

  currency: {
    fontSize: '27px',
    fontWeight: 600,
    lineHeight: '16px'
  },

  priceAmountRightFrame: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },

  priceAmountUnit: {
    fontSize: '18px',
    fontWeight: 325,
    lineHeight: '16px'
  },

  priceAmountBeforeDot: {
    fontSize: '78px',
    fontWeight: 600,
    lineHeight: '46px',
    paddingRight: '2px'
  },

  priceAmountAfterDot: {
    fontSize: '27px',
    fontWeight: 600,
    lineHeight: '16px'
  },

  voucher: {
    color: neonLime
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    paddinTop: '16px'
  },

  inputFrame: {
    display: 'flex',
    flexDirection: 'column',
    height: 'auto',
    gap: '8px'
  },

  input: {
    borderRadius: '9999px',
    backgroundColor: '#F2F1F31A',
    height: '46px',
    width: '320px',
    border: 'none',
    paddingLeft: '24px',
    fontSize: '16px',
    lineHeight: '100%',
    fontWeight: 500,
    fontFamily: 'GTWalsheim',
    color: white
  },

  button: {
    height: '48px',
    padding: '13px 22px',
    borderRadius: '9999px',
    backgroundColor: neonLime,
    color: black,
    fontSize: '16px',
    lineHeight: '100%',
    textTransform: 'uppercase',
    fontFamily: 'GothamRounded',
    fontWeight: 500,
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: neonLimeLight
    },
    '&:active': {
      backgroundColor: neonLimeDark
    }
  },

  errorBorder: {
    border: `1px solid ${red}`
  },

  error: {
    color: red,
    fontSize: '14px',
    paddingLeft: '2px'
  },

  [MediaQueries.Tablet]: {
    title: {
      fontSize: '40px'
    },

    description: {
      fontSize: '20px'
    },

    currency: {
      fontSize: '36px',
      lineHeight: '8px'
    },

    originalPrice: {
      fontSize: '18px',
      marginBottom: '22px'
    },

    priceAmountBeforeDot: {
      fontSize: '105px'
    },

    priceAmountAfterDot: {
      fontSize: '36px',
      lineHeight: '10px'
    },

    priceAmountUnit: {
      fontSize: '24px',
      lineHeight: '10px'
    },

    priceAmount: {
      marginBottom: '22px'
    },

    text: {
      fontSize: '24px'
    },

    content: {
      flexDirection: 'row'
    },

    inputFrame: {
      height: '75px'
    },

    input: {
      width: '350px'
    }
  }
})

export default useStyles
